import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { TrendingUp } from "lucide-react";
import { translateFr as tfr } from "@/i18n";

const DIMENSIONS = {
  pipeline: { label: "Progression du pipeline", tip: tfr("Faites avancer vos athlètes d'étape en étape.") },
  followup: { label: tfr("Régularité des relances"), tip: tfr("Interagissez avec chaque athlète actif au moins tous les 14 jours.") },
  results: { label: tfr("Résultats & conversions"), tip: tfr("Transformez les discussions en mandats signés.") },
  activity: { label: tfr("Régularité de l'activité"), tip: tfr("Enregistrez des interactions plusieurs jours par semaine.") },
  responseTime: { label: tfr("Temps de réponse"), tip: tfr("Contactez les nouveaux athlètes dans les 24 heures.") },
  portfolioQuality: { label: tfr("Qualité du portefeuille"), tip: tfr("Complétez les profils et gardez les documents à jour.") },
};

export default function ScoreBreakdown({ open, onOpenChange, score }) {
  const breakdown = score?.breakdown || {};
  const weights = score?.weights || {};
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="perf-score-breakdown">
        <DialogTitle className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-athlynx" /> Comprendre mon score
        </DialogTitle>
        <DialogDescription>
          {score?.value != null
            ? <>Score global : <span className="text-foreground font-semibold">{score.value} /100</span> — {score.label}</>
            : tfr("Pas encore assez d'historique pour calculer votre score.")}
        </DialogDescription>
        <div className="space-y-3 mt-1">
          {Object.entries(DIMENSIONS).map(([key, d]) => {
            const v = breakdown[key];
            const w = Math.round((weights[key] || 0) * 100);
            const weak = v != null && v < 50;
            return (
              <div key={key} data-testid={`perf-score-dim-${key}`}>
                <div className="flex items-center justify-between text-xs mb-1">
                  <span className="text-foreground/85">{d.label} <span className="text-muted-foreground">· {w}%</span></span>
                  <span className={`tabular-nums font-medium ${v == null ? "text-muted-foreground" : v >= 70 ? "text-emerald-600 dark:text-emerald-400" : weak ? "text-rose-600 dark:text-rose-400" : "text-amber-600 dark:text-amber-400"}`}>
                    {v != null ? `${v} /100` : "—"}
                  </span>
                </div>
                <div className="h-1.5 rounded-full bg-secondary overflow-hidden" role="progressbar" aria-valuenow={v ?? 0} aria-valuemin={0} aria-valuemax={100} aria-label={d.label}>
                  <div className={`h-full rounded-full ${v >= 70 ? "bg-emerald-500" : weak ? "bg-rose-500" : "bg-amber-500"}`} style={{ width: `${v || 0}%` }} />
                </div>
                {weak && <p className="text-[11px] text-muted-foreground mt-1">{d.tip}</p>}
              </div>
            );
          })}
        </div>
        <p className="text-[11px] text-muted-foreground mt-2">
          {tfr("Score déterministe calculé à partir de vos données réelles : transitions du pipeline (25%), relances (20%), résultats (20%), régularité (15%), temps de réponse (10%), qualité du portefeuille (10%).")}
        </p>
      </DialogContent>
    </Dialog>
  );
}
